<template>
  <div class="row" v-if="status">
    <div class="col-md-3 col-sm-12 px-0 _bg-card-dashboard">
      <label for="" class="_img_text_sub text-capitalize"
        >Jumlah seluruh cabang klinik</label
      >
      <label for="" class="_img_text text-capitalize">{{
        this.formData.jumlah_cabang_klinik
      }}</label>
      <img
        src="@/assets/img/background_1.png"
        alt="card dashboard"
        class="img-welcome"
        style="width:100% !important"
      />
    </div>
    <div class="col-md-3 col-sm-12 px-0 _bg-card-dashboard">
      <label for="" class="_img_text_sub text-capitalize"
        >Total Dokter seluruh cabang klinik</label
      >
      <label for="" class="_img_text text-capitalize">{{
        this.formData.jumlah_dokter_seluruh_cabang
      }}</label>
      <img
        src="@/assets/img/background_2.png"
        alt="card dashboard"
        style="width:100% !important"
      />
    </div>
    <div class="col-md-3 col-sm-12 px-0 _bg-card-dashboard">
      <label for="" class="_img_text_sub text-capitalize"
        >total pendapatan seluruh cabang hari ini</label
      >
      <label for="" class="_img_text-rp text-capitalize"
        >Rp.{{
          this.formData.total_pendapatan_cabang_hari_ini
            .toFixed()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        }},-</label
      >
      <img
        src="@/assets/img/background_4.png"
        alt="card dashboard"
        style="width:100% !important"
      />
    </div>
    <div class="col-md-3 col-sm-12 px-0 _bg-card-dashboard">
      <label for="" class="_img_text_sub text-capitalize"
        >total pendapatan seluruh cabang bulan ini</label
      >
      <label for="" class="_img_text-rp text-capitalize"
        >Rp.{{
          this.formData.total_pendapatan_cabang_bulan_ini
            .toFixed()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        }},-</label
      >
      <img
        src="@/assets/img/background_3.png"
        alt="card dashboard"
        style="width:100% !important"
      />
    </div>
    <div class="col-md-4 mt-4">
      <div class="card">
        <div class="card-body text-center">
          <strong style="font-size: 15pt">Top 5 Klinik Pendapatan Tertinggi</strong>
          <br />
          <strong>{{ month }} {{ now }}</strong>
          <br/>
          <small style="font-weight:650;color:grey">Last update: Hari ini, {{ date }}</small>
          <div class="row mt-3">
            <b-table
              hover
              thead-tr-class="izd-dashboard-table"
              style="font-size:12pt; zoom:80%"
              :fields="klinikPendapatanTertinggiFields"
              :items="dataTable"
            >
              <template v-slot:cell(pendapatan)="data">
                <span style="color:#6FE12F;font-weight:600;">{{
                  data.value
                }}</span>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 mt-4">
      <div class="card">
        <div class="card-body">
          <small style="font-weight:650;color:grey">Tahun {{ now }}</small>
          <br />
          <strong>Total Kunjungan Pasien/bulan seluruh cabang</strong>
          <BarChart
            :data-bar="barChartData"
            class="__zoom_kunjungan_pasien"
            v-if="true"
          />
        </div>
      </div>
    </div>
    <div class="col-md-4 mt-4" style="zoom:91%">
      <div class="card p-3">
        <div class="row">
          <div class="col-md-6" style="display:flex">
            <div class="mt-2">
              <img
                src="@/assets/total_pasien_terdaftar.png"
                style="width:56px"
              />
            </div>
            <div class="ml-2">
              <small style="font-weight:650;color:grey">Tahun {{ now }}</small>
              <br />
              <strong style="font-weight:700">{{
                formData.total_pasien_terdaftar
              }}</strong>
              <br />
              <label for="" class="text-capitalize" style="font-size:12pt"
                >Total Pasien terdaftar</label
              >
            </div>
          </div>
          <div class="col-md-6 pl-0" style="display:flex">
            <div class="mt-2">
              <img src="@/assets/total_pasien_baru.png" style="width:56px" />
            </div>
            <div class="ml-2">
              <br />
              <strong style="font-weight:700">{{
                formData.total_pasien_baru_hari_ini
              }}</strong>
              <br />
              <label for="" class="text-capitalize" style="font-size:12pt"
                >Total Pasien baru hari ini</label
              >
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="card p-2">
        <div class="row" style="zoom:90%">
          <div class="col-md-12 mt-2">
            <strong>Demografi Pasien</strong>
            <div class="float-right" style="display:flex">
              <div class="__square_male"></div>
              <small class="mr-4">
                Male
              </small>
              <div class="__square_female"></div>
              <small>
                Female
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <img src="@/assets/img/man.png" class="__icon-chart-man" />
            <span class="__icon-chart-man-text"
              >{{
                formData.demografi_pasien.persentase_total_pasien_male
              }}%</span
            >
            <img src="@/assets/img/woman.png" class="__icon-chart-woman" />
            <span class="__icon-chart-woman-text"
              >{{
                formData.demografi_pasien.persentase_total_pasien_female
              }}%</span
            >
            <PieChartRemoveTooltip
              :data-pie="pieChartData"
              style="zoom: 145%;height:150px"
            />
          </div>
          <div class="col-md-6 pl-0" style="font-weight:600; zoom:90%">
            <!-- 0-18 -->
            <div class="mt-5">
              <div style="width:80%;display:flex">
                <span
                  style="position:absolute;z-index:4;color:black; top: 20%;"
                  class="ml-2"
                  >0-18</span
                >

                <div
                  class="male __bar-male  p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_male_usia_0_sampai_18 +
                      '%;'
                  "
                ></div>

                <div
                  class="female __bar-female p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_female_usia_0_sampai_18 +
                      '%;'
                  "
                ></div>
              </div>

              <span class="persenan_pie" style="top: 20%;"
                >{{
                  formData.demografi_pasien.persentase_usia_0_sampai_18
                }}%</span
              >
            </div>

            <!-- 19-25 -->

            <div class="mt-2">
              <div style="width:80%; display:flex;">
                <span
                  style="position:absolute;z-index:4;color:black;top:31%;"
                  class="ml-2"
                  >19-25</span
                >
                <div
                  class="male __bar-male  p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_male_usia_19_sampai_25 +
                      '%;'
                  "
                ></div>

                <div
                  class="female __bar-female p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_female_usia_19_sampai_25 +
                      '%;'
                  "
                ></div>

                <span class="persenan_pie" style="top:31%;"
                  >{{
                    formData.demografi_pasien.persentase_usia_19_sampai_25
                  }}%</span
                >
              </div>
            </div>

            <!-- 26-35 -->
            <div class="mt-2">
              <div style="width:80%;display:flex">
                <span
                  style="position:absolute;z-index:4;color:black;top:43%;"
                  class="ml-2"
                  >26-35</span
                >
                <div
                  class="male __bar-male  p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_male_usia_26_sampai_35 +
                      '%;'
                  "
                ></div>

                <div
                  class="female __bar-female p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_female_usia_26_sampai_35 +
                      '%;'
                  "
                ></div>
              </div>

              <span class="persenan_pie" style="top:43%;"
                >{{
                  formData.demografi_pasien.persentase_usia_26_sampai_35
                }}%</span
              >
            </div>

            <!-- 36-55 -->
            <div class="mt-2">
              <div style="width:80%;display:flex">
                <span
                  style="position:absolute;z-index:4;color:black;top:54.4%;"
                  class="ml-2"
                  >36-55</span
                >

                <div
                  class="male __bar-male  p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_male_usia_36_sampai_55 +
                      '%;'
                  "
                ></div>

                <div
                  class="female __bar-female p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_female_usia_36_sampai_55 +
                      '%;'
                  "
                ></div>
              </div>

              <span class="persenan_pie" style="top:55%;"
                >{{
                  formData.demografi_pasien.persentase_usia_36_sampai_55
                }}%</span
              >
            </div>

            <!-- 56 -->
            <div class="mt-2">
              <div style="width:80%; display:flex">
                <span
                  style="position:absolute;z-index:4;color:black;top:65.6%;"
                  class="ml-2"
                  >>56</span
                >
                <div
                  class="male __bar-male  p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_male_usia_lebih_dari_56 +
                      '%;'
                  "
                ></div>

                <div
                  class="female __bar-female p-0"
                  :style="
                    'width:' +
                      formData.demografi_pasien
                        .persentase_female_usia_lebih_dari_56 +
                      '%;'
                  "
                ></div>
              </div>

              <span class="persenan_pie" style="top:66%;"
                >{{
                  formData.demografi_pasien.persentase_usia_lebih_dari_56
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="true">
      <div class="col-md-4 mt-4">
        <div class="card">
          <div class="card-body text-center">
            <strong style="font-size: 15pt">Top 5 Klinik Kunjungan Pasien Tertinggi</strong>
              <br />
              <strong>{{ month }} {{ now }}</strong>
              <br/>
              <small style="font-weight:650;color:grey">Last update: Hari ini, {{ date }}</small>
              <BarChartLabel
                :data="top5KlinikKunjunganChart"
                style="height:225px"
              />
          </div>
        </div>
        <div class="card mt-4">
            <div class="card-body text-center">
              <strong style="font-size: 15pt">Top 5 Dokter</strong>
              <br />
              <strong>{{ month }} {{ now }}</strong>
              <br/>

              <small style="font-weight:650;color:grey">Last update: Hari ini, {{ date }}</small>
              <b-table
                hover
                thead-tr-class="izd-dashboard-table"
                style="font-size:12pt; zoom:80%"
                :fields="dokterPasienTerbanyakFields"
                :items="top5DokterPasienTerbanyak"
              >
              </b-table>
            </div>
          </div>
      </div>

      <div class="col-md-8 mt-4">
        <div class="card">
          <div class="card-body">
            <LaporanPendapatanManajemen />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
moment.locale("id");

export default {
  components: {
    BarChart: () => import("@/views/Home/BarChart"),
    BarChartLabel: () => import("@/views/Home/BarChartLabel"),
    PieChartRemoveTooltip: () => import("@/views/Home/PieChartRemoveTooltip"),
    LaporanPendapatanManajemen: () => import("@/views/Home/LaporanPendapatanManajemen"),
  },
  data() {
    return {
      items: [],
      formData: null,
      dataTable: null,
      cewek: 100,
      cowok: 40,
      status: false,
      barChartData: [],
      pieChartData: [],
      top5KlinikKunjunganChart: [],
      top5DokterPasienTerbanyak: [],
      klinikPendapatanTertinggiFields: [
        {
          key: 'nama_klinik',
          thStyle: 'width: 35%; text-align: left !important;',
          tdClass: 'text-left'
        },
        {
          key: 'lokasi',
          thStyle: 'width: 40%; text-align: left !important;',
          tdClass: 'text-left'
        },
        {
          key: 'pendapatan',
          thStyle: 'width: 25%; text-align: right',
          tdClass: 'text-right'
        }
      ],
      dokterPasienTerbanyakFields: [
      {
          key: 'nama_dokter',
          thStyle: 'width: 35%; text-align: left !important;',
          tdClass: 'text-left'
        },
        {
          key: 'nama_klinik',
          thStyle: 'width: 40%; text-align: left !important;',
          tdClass: 'text-left'
        },
        {
          key: 'jumlah_pasien',
          thStyle: 'width: 25%; text-align: right',
          tdClass: 'text-right'
        }
      ]
    };
  },
  mounted() {
    this.getData();
    this.colorBar();
  },
  computed: {
    ...mapGetters({
      getKlinikId: "getKlinikId"
    }),
    now() {
      return moment(new Date()).format("YYYY");
    },
    month() {
      return moment(new Date()).format('MMMM');
    },
    date() {
      return moment(new Date()).format("DD MMM YYYY");
    }
  },
  methods: {
    async getData() {
      try {
        const res = await axios.get(
          `${this.url_api}/dash-pasien?klinik_id=${this.getKlinikId}&is_owner=true`
        );

        const { data } = res.data;

        //bar chart
        let a = data.kunjungan_pasien_perbulan.map(item => {
          return item[1];
        });

        this.barChartData = [
          {
            label: "Pasien",
            backgroundColor: "#c6d9ff",
            borderColor: "#c6d9ff",
            data: a,
            borderWidth: 5,
            borderRadius: {
              topLeft: 10,
              topRight: 10
            },
            borderSkipped: false
          }
        ];

        //pie chart
        this.pieChartData = [
          {
            backgroundColor: ["#bef2ff", "#359dc6"],
            //data pertama cewe, kedua cowok
            data: [
              data.demografi_pasien.persentase_total_pasien_female,
              data.demografi_pasien.persentase_total_pasien_male
            ]
          }
        ];

        // top 5
        let dataTop5 = [];
        let dataTop5_labels = [];
        data.top_5_klinik_kunjungan_tertinggi.forEach(item => {
          dataTop5_labels.push(item.nama_klinik);
          dataTop5.push(item.kunjungan);
        })

        this.top5KlinikKunjunganChart = {
          labels: dataTop5_labels,
          datasets: [
            {
              label: 'Klinik',
              backgroundColor: "#c6d9ff",
              borderColor: "#c6d9ff",
              data: dataTop5,
              borderWidth: 5,
              borderRadius: {
                topLeft: 10,
                topRight: 10
              },
              borderSkipped: false,
              hoverBackgroundColor: '#5c64cd',
              hoverBorderColor: '#5c64cd'
            }
          ]
        };

        this.formData = data;

        this.dataTable = data.top_5_klinik_pendapatan_tertinggi.map(item => {
          return {
            nama_klinik: item.nama_klinik,
            lokasi: item.lokasi,
            pendapatan:
              "Rp. " +
              item.pendapatan
                .toFixed()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
          };
        });

        this.top5DokterPasienTerbanyak = data.top_5_dokter_pasien_tertinggi;

        this.status = true;
        this.colorBar();
        
      } catch (error) {}
    },
    colorBar() {
      let color = [];
      let month = new Date().getMonth();
      for (let i = 0; i < 12; i++) {
        if (i == month) color.push("#4a85fb");
        else if (i > month) color.push("#1C00ff00");
        else color.push("#c6d9ff");
      }
      if(this.barChartData[0]) {
        this.barChartData[0].backgroundColor = color;
        this.barChartData[0].borderColor = color;
      }
    }
  }
};
</script>

<style>
.izd-dashboard-table th {
  border-top: 0px;
  background-color: transparent !important;
}
</style>

<style scoped>
.persenan_pie {
  color: black;
  font-size: 14px;
  float: right;
  position: absolute;
  right: 10%;
}

.__bar-male {
  background-color: #359dc6;
  height: 20px;
}

.__bar-female {
  background-color: #bef2ff;
  height: 20px;
}

.__square_male {
  height: 10px;
  width: 10px;
  background-color: #359dc6;
  margin-top: 4px;
  margin-right: 5px;
}
.__square_female {
  height: 10px;
  width: 10px;
  margin-top: 4px;
  margin-right: 5px;
  background-color: #bef2ff;
}

.__icon-chart-man {
  position: absolute;
  top: 40%;
  height: 18%;
  /* z-index: 1; */
  right: 53%;
}
.__icon-chart-man-text {
  position: absolute;
  top: 58%;
  height: 18%;
  /* z-index: 1; */
  right: 52.3%;
  font-size: 12px;
  font-weight: 600;
}
.__icon-chart-woman {
  position: absolute;
  /* z-index: 1; */
  height: 18%;
  top: 40%;
  right: 37%;
}
.__icon-chart-woman-text {
  position: absolute;
  /* z-index: 1; */
  height: 18%;
  top: 58%;
  right: 35.7%;
  font-size: 12px;
  font-weight: 600;
}

._img_text_sub {
  position: absolute !important;
  font-size: 110%;
  color: beige;
  font-weight: 650;
  padding: 6.2%;
  z-index: 1;
}

._img_text {
  position: absolute !important;
  font-size: 4.6em;
  color: beige;
  font-weight: 650;
  margin-top: 12%;
  margin-left: 6%;
  z-index: 1;
}

._img_text-rp {
  position: absolute !important;
  font-size: 28px;
  color: beige;
  font-weight: 650;
  margin-top: 22.3%;
  padding-left: 7%;
  z-index: 1;
}

@media only screen and (max-width: 1380px) and (min-width: 1100px) {
  ._bg-card-dashboard img {
    height: 110%;
  }

  ._img_text_sub {
    font-size: 16px;
  }
  ._img_text {
    margin-top: 15.2%;
    font-size: 4.3em;
  }

  ._img_text-rp {
    font-size: 23px;
    margin-top: 24%;
    z-index: 1;
  }
}

.__zoom_kunjungan_pasien {
  transform: scale(1);
  /* width: 132%; */
  /* margin-left: -16%; */
  height: 250px;
  margin-top: 3px !important;
}

@media only screen and (max-width: 1100px) and (min-width: 900px) {
  ._img_text {
    font-size: 3em;
  }
}
</style>
